import { HttpBackend } from '../../Services/Http/HttpBackend';

export type MediaEvent = {
  event: string;
  sessionId: string;
  contentId: string;
  contentType: 'video' | 'audio';
  mediaType: string;
  timestamp: number;
  [key: string]: string | number | boolean | undefined;
};

export function submitMediaEvents(events: MediaEvent[]): Promise<void> {
  return HttpBackend.post('/analytics/media-event', { events });
}
